import React from 'react';
import {useLoaderData} from 'react-router-dom';
import {usePreloadedQuery} from "react-relay";
import graphql from "babel-plugin-relay/macro";
import PractitionersTable from "./PractitionersTable";


const Practitioners = (props) => {
  const loader = useLoaderData();
  const data = usePreloadedQuery(graphql`
    query PractitionersQuery {
      ...PractitionersTableFragment
      allIdentifierTypes {
        ...Fragments_AllIdentifierTypes
      }
      allLegalContracts {
        ...ContractFragments_AllContractsDropdown
      }
    }
  `, loader.practitionersQuery);
  return (
      <>
        <PractitionersTable practitioners={data} allLegalContracts={data.allLegalContracts} />
      </>
  );
};

export default Practitioners;
